<template>
    <div class="Footer">
      <footer id="footer" class="flex flex-col pb-16 pt-32 items-center text-center font-semibold" style="background: #1d1c1c">
        <div class="flex flex-col items-center justify-center">
            <img src="../../../public/mhardDark.png" alt="" class="w-16 h-w-16">
            <p class="mt-4 text-sm sm:text-base md:text-lg text-gray-200 opacity-75 tracking-widest text-center">{{ $t('footer.firstParagraph') }}</p>
            <div class="flex justify-center mt-4">
                <a href="mailto:m.hard268@gmail.com" class="mx-2 text-gray-200 opacity-75 hover:opacity-100">
                    <i class="text-base md:text-lg fa fa-envelope-o"></i>
                </a>
                <a href="https://github.com/m-HARD" class="mx-2 text-gray-200 opacity-75 hover:opacity-100">
                    <i class="text-base md:text-lg fa fa-github"></i>
                </a>
                <a href="#" class="mx-2 text-gray-200 opacity-75 hover:opacity-100">
                    <i class="text-base md:text-lg fa fa-twitter"></i>
                </a>
            </div>
            <div>
                <p class="text-base md:text-lg text-gray-200 opacity-75 mt-2">{{ $t('footer.builtBy') }}<a href="#">M.hard</a></p>
            </div>
        </div>
      </footer>
    </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
      return {
        
      }
  }
}
</script>